module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aw9ls"))).then(() => parcelRequire('8rm4T'));